var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoldCoinIcon = function SvgGoldCoinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gold-coin-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0a16 16 0 1 0 0 32 16 16 0 0 0 0-32m5.258 23.236L16 20.472l-5.258 2.764 1-5.854-4.248-4.146 5.878-.854L16 7.056l2.628 5.326 5.878.854-4.252 4.146z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gold-coin-icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })))));
};
export default SvgGoldCoinIcon;